module.exports = __webpack_public_path__ + "img/231.d4803b4b.png";